<template>
  <div class="nav_menu">
    <div class="nav toggle">
      <a id="menu_toggle"><i class="fa fa-bars"></i></a>
    </div>
    <nav class="nav navbar-nav">
      <ul class=" navbar-right">
        <li :class="show ? 'nav-item dropdown open show' : 'nav-item dropdown open'" style="padding-left: 15px;" v-on:click="showProfile()">
          <a href="javascript:;" class="user-profile dropdown-toggle" aria-haspopup="true" id="navbarDropdown" data-toggle="dropdown" aria-expanded="false">
            {{$t('label.hello')}} {{$store.getters.fullName}}
          </a>
          <div :class="show ? 'dropdown-menu dropdown-usermenu pull-right show' : 'dropdown-menu dropdown-usermenu pull-right'" aria-labelledby="navbarDropdown">
            <router-link class="dropdown-item" to="/admin/edit"><i class="fa fa-user pull-right"></i> {{$t('label.editProfile')}}</router-link>
            <a class="dropdown-item"  href="javascript:void(0)" v-on:click="signOut()"><i class="fa fa-sign-out pull-right"></i> Đăng xuất</a>
          </div>
        </li>
      </ul>
    </nav>
  </div>
</template>
<script>
  import apiClient from '@/axios'
  export default {
    name: 'MenuTopHeader',
    data() {
      return{
        show: false,
        fullName: ''
      }
    },
    mounted() {
      let body = document.getElementById('app');
      body.addEventListener('click', this.clickOnBody)
    },
    methods: {
      showProfile() {
        this.show = !this.show;
        event.stopPropagation();
      },
      clickOnBody() {
        this.show = false;
      },
      signOut() {
        this.$store.commit("doLogout")
        this.$router.push("/login")
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">

</style>
